module.exports = __webpack_public_path__ + "img/nginxCluster.c4191573.png";